import {
  CLAUDI_STICKERS,
  type ClaudiStickerId,
} from '../../../../domain';
import {
  CLAUDI_STICKER_ICONS,
  CLAUDI_STICKER_LOCKED_ICONS,
} from '../../../stickers/claudiStickerIcons';
import { StickerItem, type StickerItemLayout } from '../sticker_item/StickerItem';
import './StickersGrid.css';

const STICKER_ICONS = CLAUDI_STICKER_ICONS;
const LOCKED_STICKER_ICONS = CLAUDI_STICKER_LOCKED_ICONS;

/** Figma Group 1321317897 (160:16959) — five icon slots per page. */
const ICON_SLOTS: readonly StickerItemLayout[] = [
  {
    left: 122,
    top: 345.4716796875,
    width: 369.45343017578125,
    height: 336.3664245605469,
  },
  {
    left: 545,
    top: 580.2763671875,
    width: 415.21636962890625,
    height: 243.24313354492188,
  },
  {
    left: 97.61572265625,
    top: 966.1086044311523,
    width: 417.54972963355794,
    height: 231.72020091438708,
  },
  {
    left: 598.16845703125,
    top: 1082.6015625,
    width: 308.0355224609375,
    height: 294.9913330078125,
  },
  {
    left: 161,
    top: 1481.59765625,
    width: 299.8909606933594,
    height: 305.4585876464844,
  },
];

const FIRST_SLOT = ICON_SLOTS[0];
const LAST_SLOT = ICON_SLOTS[ICON_SLOTS.length - 1];
/** Same vertical gap as between slot 4 bottom and slot 5 top. */
const PAGE_GAP =
  LAST_SLOT.top - (ICON_SLOTS[3].top + ICON_SLOTS[3].height);

/**
 * Next page starts below the last sticker, not on its slot
 * (old step g_5.top − s_1.top stacked page 1 onto g_5).
 */
export const STICKERS_PAGE_STEP =
  LAST_SLOT.top + LAST_SLOT.height + PAGE_GAP - FIRST_SLOT.top;

const STICKERS = CLAUDI_STICKERS.map((def, index) => {
  const slot = ICON_SLOTS[index % ICON_SLOTS.length];
  const pageIndex = Math.floor(index / ICON_SLOTS.length);
  return {
    id: def.id,
    hint: def.hint,
    iconSrc: STICKER_ICONS[def.id],
    lockedIconSrc: LOCKED_STICKER_ICONS[def.id],
    iconLayout: {
      ...slot,
      top: slot.top + pageIndex * STICKERS_PAGE_STEP,
    },
  };
});

export type StickersGridProps = {
  /** Page index; each step shifts the group by STICKERS_PAGE_STEP. */
  page?: number;
  isStickerUnlocked?: (id: ClaudiStickerId) => boolean;
};

/** Stickers row from Figma 160:16959 — translates as one group per arrow page. */
export function StickersGrid({
  page = 0,
  isStickerUnlocked,
}: StickersGridProps) {
  return (
    <div className="stickers-grid">
      <div
        className="stickers-grid__page"
        style={{ transform: `translateY(${-page * STICKERS_PAGE_STEP}px)` }}
      >
        {STICKERS.map((sticker) => {
          const isUnlocked = isStickerUnlocked?.(sticker.id) ?? false;
          return (
            <StickerItem
              key={sticker.id}
              iconSrc={isUnlocked ? sticker.iconSrc : sticker.lockedIconSrc}
              iconLayout={sticker.iconLayout}
              ariaLabel={sticker.hint}
            />
          );
        })}
      </div>
    </div>
  );
}
